<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Conférence d'avent et de carême" />
            <ConferenceAvant />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import ConferenceAvant from './ConferenceAvant.vue';


export default {
    name: 'ConferenceAvantPage',
    components: {
        NavBar,
        PageTitle,
        ConferenceAvant,
        FooterComp,
    }
}
</script>